import { actions } from 'react-redux-form';
import * as endpoints from '../helpers/endpoints';
import * as types from './action-types';
import apiRequest from '../helpers/apiRequest';

export const handleAddOnSiteDate = onSiteAddDates => (dispatch, getState) => {
    const dates = getState().ui.onSiteAddDates.map(item =>
        item.date.toString()
    );
    if (dates.indexOf(onSiteAddDates.date.toString()) === -1) {
        dispatch(actions.omit('event', 'onSiteDate'));
        dispatch(addOnSiteDate(onSiteAddDates));
    }
};

export const addOnSiteDate = onSiteAddDates => ({
    type: types.ADD_ON_SITE_DATE,
    onSiteAddDates
});

export const setOnsiteDates = dates => {
    return {
        type: types.SET_ONSITE_DATES,
        dates
    };
};

export const deleteOnSiteDate = index => (dispatch, getState) => {
    const dates = getState().ui.onSiteAddDates.slice(0);
    const dateObj = dates[index];
    if (dateObj.id) {
        const postBody = { data: { id: dateObj.id } };
        apiRequest(
            `${endpoints.ONSITE_DATE_PATH}/delete`,
            getState().auth.jwtToken,
            'POST',
            JSON.stringify(postBody)
        ).then(payload => {
            if (payload.errors) {
                console.log(payload);
            } else {
                dates.splice(index, 1);
                dispatch(setOnsiteDates(dates));
            }
        });
    } else {
        dates.splice(index, 1);
        dispatch(setOnsiteDates(dates));
    }
};



// WEBPACK FOOTER //
// ./src/actions/on-site-date.js